import { useForm } from "@mantine/form"
import { httpsCallable } from "firebase/functions"

import { useCloudFunction } from "../../../../hooks/useCloudFunction"
import { firebase } from "../../../../services/firebase/firebase"
import { AwsLambdaUpdateThingData } from "../../../../functions/aws/lambda/aws-lambda-updateThing"
import { Attribute, DeviceDocument } from "../../../../contexts/devices-context"
import { AwsLambdaUpdateGroupData } from "../../../../functions/aws/lambda/aws-lambda-updateGroup"
import { useLanguage } from "../../../../contexts/language-context"

export default (
    attrs: (Record<"brightness", Attribute>) | undefined,
    organisation: string,
    group: string,
    device?: DeviceDocument,
) => {
    const { onStart, onSuccess, onError, processing } = useCloudFunction(
        device ? "aws-lambda-updateThing" : "aws-lambda-updateGroup",
    )
    const { L } = useLanguage()
    const form = useForm({
        initialValues: {
            on: attrs?.brightness.value !== null && attrs?.brightness.value !== 0,
            brightness: typeof attrs?.brightness.value === "number" ? Math.round(attrs.brightness.value / 2.56) : null
        },
    })

    const onSubmit = async (values: typeof form.values) => {
        onStart(L("Updating setting..."))

        const module = {
            name: "lights",
            attributes: [
                ...((form.isDirty("brightness") || form.isDirty("on")) && attrs?.brightness.mutable
                    ? [
                        {
                            name: "brightness",
                            value: values.brightness !== null
                                ? values.on
                                    ? Math.round(values.brightness * 2.56)
                                    : 0
                                : null,
                        },
                    ]
                    : []),
            ] as Attribute[],
        }

        try {
            if (device) {
                await httpsCallable<AwsLambdaUpdateThingData>(
                    firebase.functions,
                    "aws-lambda-updateThing",
                )({
                    id: device.id,
                    group,
                    organisation,
                    module,
                })
            } else {
                await httpsCallable<AwsLambdaUpdateGroupData>(
                    firebase.functions,
                    "aws-lambda-updateGroup",
                )({
                    id: group,
                    organisation,
                    module,
                })
            }

            form.resetDirty(values)
            onSuccess()()
        } catch (error) {
            onError()(error)
        }
    }

    return {
        form,
        onSubmit,
        reset: form.reset,
        inheritSettings: () => form.setValues({ on: false, brightness: null }),
        processing,
        attrs,
    }
}
